import Swiper, { Navigation, Pagination, EffectFade } from 'swiper/core'; // eslint-disable-line

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade]);

const initTabs = () => {
  const tabsComponents = document.querySelectorAll('.o-tabs');

  tabsComponents.forEach(($tabsComponents) => {
    const $slider = $tabsComponents.querySelector('.swiper-container');

    // Create array with titles
    const slideTitles = [];

    $slider.querySelectorAll('.swiper-slide').forEach(($slide) => {
      slideTitles.push($slide.getAttribute('data-title'));
    });

    // eslint-disable-next-line
    const slider = new Swiper($slider, {
      observer: true,
      observeSlideChildren: true,
      virtualTranslate: true,
      autoHeight: true,
      watchOverflow: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.o-tabs__pagination',
        clickable: true,
        renderBullet: (index, className) => `<button class="o-tabs__pagination-bullet ${className}">${slideTitles[index]}</button>`,
        bulletClass: 'o-tabs__pagination-bullet',
        bulletActiveClass: 'o-tabs__pagination-bullet--active',
        clickableClass: 'o-tabs__pagination-bullet--clickable',
      },
    });

    /*
     * Re-init and update slider when slide is changed
     * It's neccessary for asyncronous loaded content
     */
    slider.on('slideChange', () => {
      slider.init();
      slider.update();
    });
  });
};

initTabs();
